import { Dialog } from "primereact/dialog";
import { IUserMast } from "../../models/UserMast";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { Fetch } from "../../shared/Fetch";
import { set } from "date-fns";
import { JVCheckbox } from "../../shared/JVCheckbox";

interface IProps {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    singleData: IUserMast,
}

export interface ILeads {
    team_Lead?: number,
    resource_Manager?: number,
    head?: number,
}

const schema = yup.object({
    
});

export const Heads = (props: IProps) => {
    const [teamLeads, setTeamLeads] = useState<Array<IUserMast>>([]);
    const [resourceManager, setResourceManager] = useState<Array<IUserMast>>([]);
    const [head, setHead] = useState<Array<IUserMast>>([]);
    const [loading, setLoading] = useState(false);
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false,
    });

    function onSubmit(data: ILeads) {
        saveToDB(data);
    };

    const saveToDB = async (data: ILeads) => {
        let newData: any = data;
        newData.login_ID = props.singleData.login_ID;
        const response = await Fetch("User_Mast/updateHeads", "PUT", newData, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Leads Updated Successfully", life: 3000 });
            props.setReload(!props.reload);
            onHide();
        } else props.toast.current.show({ severity: 'error', detail: "Something went wrong", life: 3000 });
    };

    const loadTeamLead = async () => {
        const response = await Fetch("DropDown/getLeadsList", "GET", null, `type=teamLead&login_ID=${props.singleData.login_ID}`, props.toast);
        if (response) {
            const data: IUserMast[] = await response.json();
            setTeamLeads(prev => prev = data);
            if (props.open && props.singleData?.team_Lead != null && data.length > 0) {
                setValue("team_Lead", props.singleData.team_Lead);
            }
        }
    };
    const loadResourceManager = async () => {
        const response = await Fetch("DropDown/getLeadsList", "GET", null, `type=resourceManager&login_ID=${props.singleData.login_ID}`, props.toast);
        if (response) {
            const data: IUserMast[] = await response.json();
            setResourceManager(prev => prev = data);
            if (props.open && props.singleData?.resource_Manager != null && data.length > 0) {
                setValue("resource_Manager", props.singleData.resource_Manager);
            }
        }
    };
    const loadHead = async () => {
        const response = await Fetch("DropDown/getLeadsList", "GET", null, `type=head&login_ID=${props.singleData.login_ID}`, props.toast);
        if (response) {
            const data: IUserMast[] = await response.json();
            setHead(prev => prev = data);
            if (props.open && props.singleData?.head != null && data.length > 0) {
                setValue("head", props.singleData.head);
            }
        }
    };

    const onHide = () => {
        reset({});
        props.hideDialog();
    };
    useEffect(() => {
        if (props.open) {
            loadTeamLead();
            loadResourceManager();
            loadHead();
        }
    }, [props.open]);

    useEffect(() => {
    }, [teamLeads, resourceManager, head, props.open]);


    useEffect(() => {
        if (props.open) {
            reset({
                recruiter_Head: props.singleData?.recruiter_Head,
                isResourceManager: props.singleData?.isResourceManager,
                sales_Head: props.singleData?.sales_Head,
            });
        }
    }, [props.open, props.singleData]);


    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit User Heads" modal className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVCheckbox column={4}  label="Recruiter head" control={control} name="recruiter_Head" />
                    <JVCheckbox column={4}  label="Sales Head" control={control} name="sales_Head" />
                    <JVCheckbox column={2} label="Resource Manager" control={control} name="isResourceManager" />
                    <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                        <Button className="field col-12 md:col-6  h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                        <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div>
                </form>
            </Dialog>
        </>
    );
}